// extracted by mini-css-extract-plugin
export default {"textarea":"OwnCode_textarea__DmdDd","textareaContainer":"OwnCode_textareaContainer__+2H2i"};